export const displayCard = [
  "backlinks",
  "anchors",
  "refdomains",
  "inlink_rank",
];
export const summaryList = [
  "backlinks",
  "refdomains",
  "dofollow_backlinks",
  "inlink_rank",
];
export const allSummaryList = [
  "target",
  "backlinks",
  "refdomains",
  "subnets",
  "ips",
  "nofollow_backlinks",
  "dofollow_backlinks",
  "edu_backlinks",
  "gov_backlinks",
  "inlink_rank",
  "domain_inlink_rank",
  "from_home_page_backlinks",
  "dofollow_from_home_page_backlinks",
  "text_backlinks",
  "dofollow_refdomains",
  "from_home_page_refdomains",
  "edu_refdomains",
  "gov_refdomains",
  "anchors",
  "dofollow_anchors",
  "pages_with_backlinks",
];

export const data = {
  signin: {
    title: "Sign In",
    slug: "/auth/signin",
  },
  primaryNavigation: [
    {
      title: "Audit",
      slug: "/audit",
    },
    {
      title: "AI Analysis",
      slug: "/ai/overview",
    },
    {
      title: "Keywords",
      slug: "/keywords",
    }
  ],
  dashboardNavigation: [
    {
      title: "Dashboard",
      slug: "/dashboard",
      icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWxheW91dC1kYXNoYm9hcmQiPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjkiIHg9IjMiIHk9IjMiIHJ4PSIxIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iNSIgeD0iMTQiIHk9IjMiIHJ4PSIxIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iOSIgeD0iMTQiIHk9IjEyIiByeD0iMSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjUiIHg9IjMiIHk9IjE2IiByeD0iMSIvPjwvc3ZnPg==",
    },
    {
      title: "Audit",
      slug: "/dashboard/audit-report",
      icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoYXJ0LW5ldHdvcmsiPjxwYXRoIGQ9Im0xMy4xMSA3LjY2NCAxLjc4IDIuNjcyIi8+PHBhdGggZD0ibTE0LjE2MiAxMi43ODgtMy4zMjQgMS40MjQiLz48cGF0aCBkPSJtMjAgNC02LjA2IDEuNTE1Ii8+PHBhdGggZD0iTTMgM3YxNmEyIDIgMCAwIDAgMiAyaDE2Ii8+PGNpcmNsZSBjeD0iMTIiIGN5PSI2IiByPSIyIi8+PGNpcmNsZSBjeD0iMTYiIGN5PSIxMiIgcj0iMiIvPjxjaXJjbGUgY3g9IjkiIGN5PSIxNSIgcj0iMiIvPjwvc3ZnPg==",
    },
    {
      title: "Statistics",
      slug: "/dashboard/statistics",
      icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoYXJ0LW5vLWF4ZXMtY29tYmluZWQiPjxwYXRoIGQ9Ik0xMiAxNnY1Ii8+PHBhdGggZD0iTTE2IDE0djciLz48cGF0aCBkPSJNMjAgMTB2MTEiLz48cGF0aCBkPSJtMjIgMy04LjY0NiA4LjY0NmEuNS41IDAgMCAxLS43MDggMEw5LjM1NCA4LjM1NGEuNS41IDAgMCAwLS43MDcgMEwyIDE1Ii8+PHBhdGggZD0iTTQgMTh2MyIvPjxwYXRoIGQ9Ik04IDE0djciLz48L3N2Zz4=",
    },
    {
      title: "Targets",
      slug: "/dashboard/targets",
      icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXRhcmdldCI+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI2Ii8+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMiIvPjwvc3ZnPg==",
    },
  ],
  cartData: [
    {
      website: "website001",
      url: "Paid",
      price: "$250.00",
      keywords: "Credit Card",
      noOfLinks: 5,
    },
    {
      website: "website002",
      url: "Pending",
      price: "$150.00",
      keywords: "PayPal",
      noOfLinks: 5,
    },
    {
      website: "website003",
      url: "Unpaid",
      price: "$350.00",
      keywords: "Bank Transfer",
      noOfLinks: 5,
    },
    {
      website: "website004",
      url: "Paid",
      price: "$450.00",
      keywords: "Credit Card",
      noOfLinks: 5,
    },
    {
      website: "website005",
      url: "Paid",
      price: "$550.00",
      keywords: "PayPal",
      noOfLinks: 5,
    },
    {
      website: "website006",
      url: "Pending",
      price: "$200.00",
      keywords: "Bank Transfer",
      noOfLinks: 5,
    },
    {
      website: "website007",
      url: "Unpaid",
      price: "$300.00",
      keywords: "Credit Card",
      noOfLinks: 5,
    },
  ],
  dummyLinks: [
    {
      url: "https://www.amazon.com/dp/B09G3HRMVS",
      website: "Amazon",
      description: "A stylish wireless keyboard.",
      price: 29.99,
      keyword: "keyboard",
    },
    {
      url: "https://www.flipkart.com/smartphone-case",
      website: "Flipkart",
      description: "Durable smartphone case.",
      price: 12.49,
      keyword: "smartphone",
    },
    {
      url: "https://www.ebay.com/itm/2548974723",
      website: "eBay",
      description: "Vintage wristwatch.",
      price: 50.0,
    },
    {
      url: "https://www.etsy.com/listing/1014523498",
      website: "Etsy",
      description: "Handmade ceramic mug.",
      price: 15.0,
      keyword: "ceramic",
    },
    {
      url: "https://www.bestbuy.com/site/product/12345",
      website: "Best Buy",
      description: "High-definition smart TV.",
      price: 499.99,
      keyword: "smart TV",
    },
    {
      url: "https://www.target.com/p/portable-speaker",
      website: "Target",
      description: "Portable Bluetooth speaker.",
      price: 25.99,
    },
    {
      url: "https://www.walmart.com/ip/laptop-bag",
      website: "Walmart",
      description: "Waterproof laptop bag.",
      price: 39.99,
      keyword: "bag",
    },
    {
      url: "https://www.apple.com/shop/product/MME73AM/A",
      website: "Apple",
      description: "AirPods with charging case.",
      price: 159.0,
    },
    {
      url: "https://www.nike.com/t/air-force-1",
      website: "Nike",
      description: "Classic Air Force 1 shoes.",
      price: 90.0,
      keyword: "shoes",
    },
    {
      url: "https://www.adidas.com/us/running-shoes",
      website: "Adidas",
      description: "Comfortable running shoes.",
      price: 85.0,
    },
    {
      url: "https://www.zara.com/us/women-jackets",
      website: "Zara",
      description: "Trendy women's jacket.",
      price: 49.99,
    },
    {
      url: "https://www.hm.com/us/product/outerwear",
      website: "H&M",
      description: "Casual outerwear for men.",
      price: 39.99,
      keyword: "outerwear",
    },
    {
      url: "https://www.bookdepository.com/best-books-2023",
      website: "Book Depository",
      description: "Bestselling books of 2023.",
      price: 20.0,
    },
    {
      url: "https://www.udemy.com/course/javascript-basics",
      website: "Udemy",
      description: "Learn JavaScript basics.",
      price: 15.0,
      keyword: "JavaScript",
    },
    {
      url: "https://www.coursera.org/specializations/python",
      website: "Coursera",
      description: "Python programming specialization.",
      price: 39.99,
      keyword: "Python",
    },
    {
      url: "https://www.netflix.com/title/81040344",
      website: "Netflix",
      description: "Top-rated drama series.",
      price: 9.99,
    },
    {
      url: "https://www.spotify.com/us/premium",
      website: "Spotify",
      description: "Ad-free music streaming.",
      price: 9.99,
      keyword: "music",
    },
    {
      url: "https://www.hulu.com/start",
      website: "Hulu",
      description: "Stream your favorite TV shows.",
      price: 7.99,
    },
    {
      url: "https://www.microsoft.com/en-us/office365",
      website: "Microsoft",
      description: "Office 365 subscription.",
      price: 69.99,
      keyword: "office",
    },
    {
      url: "https://www.google.com/chrome",
      website: "Google",
      description: "Download Google Chrome browser.",
      price: 0.0,
    },
    {
      url: "https://www.tesla.com/models",
      website: "Tesla",
      description: "Electric cars by Tesla.",
      price: 35000.0,
    },
    {
      url: "https://www.samsung.com/us/smartphones",
      website: "Samsung",
      description: "Latest Galaxy smartphones.",
      price: 899.0,
      keyword: "smartphones",
    },
    {
      url: "https://www.dell.com/en-us/laptops",
      website: "Dell",
      description: "High-performance laptops.",
      price: 1199.0,
    },
    {
      url: "https://www.hp.com/us-en/laptops",
      website: "HP",
      description: "Affordable laptops for students.",
      price: 749.99,
    },
    {
      url: "https://www.lenovo.com/us/en/laptops",
      website: "Lenovo",
      description: "Versatile laptops for work and play.",
      price: 899.0,
      keyword: "laptops",
    },
    {
      url: "https://www.asus.com/us/monitors",
      website: "Asus",
      description: "Gaming monitors for professionals.",
      price: 199.99,
    },
    {
      url: "https://www.gopro.com/en/us/cameras",
      website: "GoPro",
      description: "Capture stunning action shots.",
      price: 349.99,
      keyword: "camera",
    },
    {
      url: "https://www.nikonusa.com/en/Camera-Lenses",
      website: "Nikon",
      description: "High-quality camera lenses.",
      price: 799.99,
    },
    {
      url: "https://www.sony.com/electronics/audio",
      website: "Sony",
      description: "Premium audio equipment.",
      price: 249.99,
    },
    {
      url: "https://www.canon.com/cameras",
      website: "Canon",
      description: "Professional-grade DSLR cameras.",
      price: 1299.99,
      keyword: "DSLR",
    },
  ],
  dummyUsers: [
    {
      name: "Alice Johnson",
      email: "alice.johnson@example.com",
      password: "$2b$10$Fc4FrSOB8A2l3Dqj5P4LjebLAJbRonIaJzcgM1vxaFFL/Ppr7tKYi",
      role: "user",
      isActive: true,
    },
    {
      name: "Bob Smith",
      email: "bob.smith@example.com",
      password: "$2b$10$tsn4DXv0j6bdTXaXKHnw/.2GUTx9DX4Q.ihoMj.phf7Strz0M6cCC",
      role: "admin",
      isActive: true,
    },
    {
      name: "Charlie Brown",
      email: "charlie.brown@example.com",
      password: "$2b$10$G8viafK6J8/r701nRWroBOefaNAvcESkpxlU5IisWJKBBqPuSYQs2",
      role: "user",
      isActive: true,
    },
    {
      name: "Diana Prince",
      email: "diana.prince@example.com",
      password: "$2b$10$4rytfdJH8hQyNhDC5IYvmeAWBt6YO8qCu0BBa0pq4OB6Dgt.8xYdW",
      role: "user",
      isActive: true,
    },
    {
      name: "Ethan Hunt",
      email: "ethan.hunt@example.com",
      password: "$2b$10$TqwzorNKIEdY5eR8RQq/LuZSVc6I98/dqA1XUm2pvnqU9C7wNA1rq",
      role: "user",
      isActive: true,
    },
    {
      name: "Fiona Gallagher",
      email: "fiona.gallagher@example.com",
      password: "$2b$10$dTebBCsOGX4whfKIAQvliOFNJYoxIwwdKqUN1JQrGwVYxwjbQb4gG",
      role: "user",
      isActive: false,
    },
    {
      name: "George Lucas",
      email: "george.lucas@example.com",
      password: "$2b$10$.NbAgoEXRdbzXfcroRo3ZOL83jNn3MklENBRoFNBemAVWSxJ3x3kS",
      role: "admin",
      isActive: true,
    },
    {
      name: "Hannah Baker",
      email: "hannah.baker@example.com",
      password: "$2b$10$5/H4qn.E095bQsXKW6IXm.VPtsuvGPOa5dsKvDJ2esZfoNlE.LYiW",
      role: "user",
      isActive: true,
    },
    {
      name: "Ian Somerhalder",
      email: "ian.somerhalder@example.com",
      password: "$2b$10$/IlFZ.ZTZVz.qTV6bnSaU.AK0Fuf/SX6AdARL0l/Ho1nMhwgZ3r0i",
      role: "user",
      isActive: true,
    },
    {
      name: "Jessica Jones",
      email: "jessica.jones@example.com",
      password: "$2b$10$cwnG2FNZkQzOnCgA0UtleOK6TAPI5Jp4wLTWKJiEQQQBggCGfPX3W",
      role: "user",
      isActive: false,
    },
  ],
  dummyCart: [
    {
      userId: "67cdb288e33e0b0c70d98b1f",
      items: [
        {
          linkId: "67cdb02917aaa8d84643f382",
          quantity: 1,
        },
        {
          linkId: "67cdb02917aaa8d84643f383",
          quantity: 2,
        },
      ],
      totalPrice: 54.97,
      createdAt: "2025-03-09T17:00:45.144+00:00",
      updatedAt: "2025-03-09T17:00:45.144+00:00",
    },
    {
      userId: "67cdb288e33e0b0c70d98b20",
      items: [
        {
          linkId: "67cdb02917aaa8d84643f384",
          quantity: 1,
        },
        {
          linkId: "67cdb02917aaa8d84643f388",
          quantity: 1,
        },
      ],
      totalPrice: 89.99,
      createdAt: "2025-03-09T17:05:45.144+00:00",
      updatedAt: "2025-03-09T17:05:45.144+00:00",
    },
    {
      userId: "67cdb288e33e0b0c70d98b21",
      items: [
        {
          linkId: "67cdb02917aaa8d84643f389",
          quantity: 1,
        },
        {
          linkId: "67cdb02917aaa8d84643f38a",
          quantity: 1,
        },
      ],
      totalPrice: 249,
      createdAt: "2025-03-09T17:10:45.144+00:00",
      updatedAt: "2025-03-09T17:10:45.144+00:00",
    },
    {
      userId: "67cdb288e33e0b0c70d98b22",
      items: [
        {
          linkId: "67cdb02917aaa8d84643f386",
          quantity: 1,
        },
      ],
      totalPrice: 499.99,
      createdAt: "2025-03-09T17:15:45.144+00:00",
      updatedAt: "2025-03-09T17:15:45.144+00:00",
    },
    {
      userId: "67cdb288e33e0b0c70d98b23",
      items: [
        {
          linkId: "67cdb02917aaa8d84643f38b",
          quantity: 1,
        },
        {
          linkId: "67cdb02917aaa8d84643f38c",
          quantity: 2,
        },
      ],
      totalPrice: 184.98,
      createdAt: "2025-03-09T17:20:45.144+00:00",
      updatedAt: "2025-03-09T17:20:45.144+00:00",
    },
    {
      userId: "67cdb288e33e0b0c70d98b24",
      items: [
        {
          linkId: "67cdb02917aaa8d84643f385",
          quantity: 4,
        },
      ],
      totalPrice: 60,
      createdAt: "2025-03-09T17:25:45.144+00:00",
      updatedAt: "2025-03-09T17:25:45.144+00:00",
    },
  ],
}; 

export const aiEngines = [
  { value: "ai-overview", text: "AEO Overview" }
];

export const countries = [
  { code: "af", label: "Afghanistan" },
  { code: "al", label: "Albania" },
  { code: "dz", label: "Algeria" },
  { code: "as", label: "American Samoa" },
  { code: "ao", label: "Angola" },
  { code: "ai", label: "Anguilla" },
  { code: "ag", label: "Antigua and Barbuda" },
  { code: "ar", label: "Argentina" },
  { code: "am", label: "Armenia" },
  { code: "aw", label: "Aruba" },
  { code: "au", label: "Australia" },
  { code: "at", label: "Austria" },
  { code: "az", label: "Azerbaijan" },
  { code: "bs", label: "Bahamas" },
  { code: "bh", label: "Bahrain" },
  { code: "bd", label: "Bangladesh" },
  { code: "bb", label: "Barbados" },
  { code: "by", label: "Belarus" },
  { code: "be", label: "Belgium" },
  { code: "bz", label: "Belize" },
  { code: "bj", label: "Benin" },
  { code: "bt", label: "Bhutan" },
  { code: "bo", label: "Bolivia" },
  { code: "ba", label: "Bosnia and Herzegovina" },
  { code: "bw", label: "Botswana" },
  { code: "br", label: "Brazil" },
  { code: "vg", label: "British Virgin Islands" },
  { code: "bn", label: "Brunei" },
  { code: "bg", label: "Bulgaria" },
  { code: "bf", label: "Burkina Faso" },
  { code: "bi", label: "Burundi" },
  { code: "cv", label: "Cabo Verde" },
  { code: "kh", label: "Cambodia" },
  { code: "cm", label: "Cameroon" },
  { code: "ca", label: "Canada" },
  { code: "ky", label: "Cayman Islands" },
  { code: "cf", label: "Central African Republic" },
  { code: "td", label: "Chad" },
  { code: "cl", label: "Chile" },
  { code: "cn", label: "China" },
  { code: "co", label: "Colombia" },
  { code: "cd", label: "Congo (Democratic Republic)" },
  { code: "cg", label: "Congo (Republic)" },
  { code: "ck", label: "Cook Islands" },
  { code: "cr", label: "Costa Rica" },
  { code: "ci", label: "Côte d’Ivoire" },
  { code: "hr", label: "Croatia" },
  { code: "cu", label: "Cuba" },
  { code: "cy", label: "Cyprus" },
  { code: "cz", label: "Czechia" },
  { code: "dk", label: "Denmark" },
  { code: "dj", label: "Djibouti" },
  { code: "dm", label: "Dominica" },
  { code: "do", label: "Dominican Republic" },
  { code: "ec", label: "Ecuador" },
  { code: "eg", label: "Egypt" },
  { code: "sv", label: "El Salvador" },
  { code: "gq", label: "Equatorial Guinea" },
  { code: "ee", label: "Estonia" },
  { code: "et", label: "Ethiopia" },
  { code: "fo", label: "Faroe Islands" },
  { code: "fj", label: "Fiji" },
  { code: "fi", label: "Finland" },
  { code: "fr", label: "France" },
  { code: "gf", label: "French Guiana" },
  { code: "pf", label: "French Polynesia" },
  { code: "ga", label: "Gabon" },
  { code: "gm", label: "Gambia" },
  { code: "ge", label: "Georgia" },
  { code: "de", label: "Germany" },
  { code: "gh", label: "Ghana" },
  { code: "gi", label: "Gibraltar" },
  { code: "gr", label: "Greece" },
  { code: "gl", label: "Greenland" },
  { code: "gd", label: "Grenada" },
  { code: "gp", label: "Guadeloupe" },
  { code: "gu", label: "Guam" },
  { code: "gt", label: "Guatemala" },
  { code: "gg", label: "Guernsey" },
  { code: "gn", label: "Guinea" },
  { code: "gy", label: "Guyana" },
  { code: "ht", label: "Haiti" },
  { code: "hn", label: "Honduras" },
  { code: "hk", label: "Hong Kong" },
  { code: "hu", label: "Hungary" },
  { code: "is", label: "Iceland" },
  { code: "in", label: "India" },
  { code: "id", label: "Indonesia" },
  { code: "iq", label: "Iraq" },
  { code: "ie", label: "Ireland" },
  { code: "im", label: "Isle of Man" },
  { code: "il", label: "Israel" },
  { code: "it", label: "Italy" },
  { code: "jm", label: "Jamaica" },
  { code: "jp", label: "Japan" },
  { code: "je", label: "Jersey" },
  { code: "jo", label: "Jordan" },
  { code: "kz", label: "Kazakhstan" },
  { code: "ke", label: "Kenya" },
  { code: "ki", label: "Kiribati" },
  { code: "kw", label: "Kuwait" },
  { code: "kg", label: "Kyrgyzstan" },
  { code: "la", label: "Laos" },
  { code: "lv", label: "Latvia" },
  { code: "lb", label: "Lebanon" },
  { code: "ls", label: "Lesotho" },
  { code: "ly", label: "Libya" },
  { code: "li", label: "Liechtenstein" },
  { code: "lt", label: "Lithuania" },
  { code: "lu", label: "Luxembourg" },
  { code: "mg", label: "Madagascar" },
  { code: "mw", label: "Malawi" },
  { code: "my", label: "Malaysia" },
  { code: "mv", label: "Maldives" },
  { code: "ml", label: "Mali" },
  { code: "mt", label: "Malta" },
  { code: "mq", label: "Martinique" },
  { code: "mr", label: "Mauritania" },
  { code: "mu", label: "Mauritius" },
  { code: "yt", label: "Mayotte" },
  { code: "mx", label: "Mexico" },
  { code: "fm", label: "Micronesia" },
  { code: "md", label: "Moldova" },
  { code: "mc", label: "Monaco" },
  { code: "mn", label: "Mongolia" },
  { code: "me", label: "Montenegro" },
  { code: "ms", label: "Montserrat" },
  { code: "ma", label: "Morocco" },
  { code: "mz", label: "Mozambique" },
  { code: "mm", label: "Myanmar" },
  { code: "na", label: "Namibia" },
  { code: "nr", label: "Nauru" },
  { code: "np", label: "Nepal" },
  { code: "nl", label: "Netherlands" },
  { code: "nc", label: "New Caledonia" },
  { code: "nz", label: "New Zealand" },
  { code: "ni", label: "Nicaragua" },
  { code: "ne", label: "Niger" },
  { code: "ng", label: "Nigeria" },
  { code: "nu", label: "Niue" },
  { code: "mk", label: "North Macedonia" },
  { code: "no", label: "Norway" },
  { code: "om", label: "Oman" },
  { code: "pk", label: "Pakistan" },
  { code: "pa", label: "Panama" },
  { code: "pg", label: "Papua New Guinea" },
  { code: "py", label: "Paraguay" },
  { code: "pe", label: "Peru" },
  { code: "ph", label: "Philippines" },
  { code: "pn", label: "Pitcairn Islands" },
  { code: "pl", label: "Poland" },
  { code: "pt", label: "Portugal" },
  { code: "pr", label: "Puerto Rico" },
  { code: "qa", label: "Qatar" },
  { code: "re", label: "Réunion" },
  { code: "ro", label: "Romania" },
  { code: "ru", label: "Russia" },
  { code: "rw", label: "Rwanda" },
  { code: "sh", label: "Saint Helena" },
  { code: "kn", label: "Saint Kitts and Nevis" },
  { code: "lc", label: "Saint Lucia" },
  { code: "vc", label: "Saint Vincent and the Grenadines" },
  { code: "ws", label: "Samoa" },
  { code: "sm", label: "San Marino" },
  { code: "st", label: "São Tomé and Príncipe" },
  { code: "sa", label: "Saudi Arabia" },
  { code: "sn", label: "Senegal" },
  { code: "rs", label: "Serbia" },
  { code: "sc", label: "Seychelles" },
  { code: "sl", label: "Sierra Leone" },
  { code: "sg", label: "Singapore" },
  { code: "sk", label: "Slovakia" },
  { code: "si", label: "Slovenia" },
  { code: "sb", label: "Solomon Islands" },
  { code: "so", label: "Somalia" },
  { code: "za", label: "South Africa" },
  { code: "kr", label: "South Korea" },
  { code: "es", label: "Spain" },
  { code: "lk", label: "Sri Lanka" },
  { code: "ps", label: "State of Palestine" },
  { code: "sr", label: "Suriname" },
  { code: "se", label: "Sweden" },
  { code: "ch", label: "Switzerland" },
  { code: "tw", label: "Taiwan" },
  { code: "tj", label: "Tajikistan" },
  { code: "tz", label: "Tanzania" },
  { code: "th", label: "Thailand" },
  { code: "tl", label: "Timor-Leste" },
  { code: "tg", label: "Togo" },
  { code: "tk", label: "Tokelau" },
  { code: "to", label: "Tonga" },
  { code: "tt", label: "Trinidad and Tobago" },
  { code: "tn", label: "Tunisia" },
  { code: "tr", label: "Türkiye" },
  { code: "tm", label: "Turkmenistan" },
  { code: "vi", label: "U.S. Virgin Islands" },
  { code: "ug", label: "Uganda" },
  { code: "ua", label: "Ukraine" },
  { code: "ae", label: "United Arab Emirates" },
  { code: "uk", label: "United Kingdom" },
  { code: "us", label: "United States" },
  { code: "uy", label: "Uruguay" },
  { code: "uz", label: "Uzbekistan" },
  { code: "vu", label: "Vanuatu" },
  { code: "ve", label: "Venezuela" },
  { code: "vn", label: "Vietnam" },
  { code: "ye", label: "Yemen" },
  { code: "zm", label: "Zambia" },
  { code: "zw", label: "Zimbabwe" },
];
